export default __webpack_public_path__ + "static/forms-c2c8e01be7b4447fc14d7e5a919a07da.png";